import { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useRegistration from "../../store/RegistrationStore";

import useApi from "../../hooks/useApi";

import MainHeader from "../../Components/MainHeader/MainHeader";
import Registration from "../Registration/Registration";
import Input from "../../Components/Input";
import RegisteredActivities from "../../Components/RegisteredActivities/RegisteredActivities";
import CountrySelect from "../../Components/CountrySelect";
import BackButton from "../../Components/BackButton";
import CustomButton from "../../Components/CustomButton";
import Loader from "../../Components/Loader";

import { renderIcon, removeExtraChars } from "./categoryIcons";

import "./style.scss";

const ProviderRegistration = () => {
  const { state } = useLocation();
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const isSSO = params.get("isSSO");
  const pricePlan = params.get("pricePlan");

  const { get, loading } = useApi();

  const [addressValidation, setAddresValidation] = useState("");
  const [otherActivityName, setOtherActivityName] = useState("");
  const [categories, setCategories] = useState([]);

  const {
    country,
    city,
    district,
    address,
    activityName,
    providerRegistrationSteps,
    registerValidation,

    changePricePlan,
    changeCountry,
    changeCity,
    changeDistrict,
    changeAddress,
    changeActivityName,
    selectCategory,
    changeProviderRegistrationSteps,
    handleExternalRegister,
  } = useRegistration();

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "activityName") {
      changeActivityName(value);
    }
    if (name === "city") {
      changeCity(value);
    }
    if (name === "district") {
      changeDistrict(value);
    }
    if (name === "address") {
      changeAddress(value);
    }
  };

  const handleSubmitAddress = (e) => {
    e.preventDefault();
    if (
      !country ||
      city.trim() === "" ||
      district.trim() === "" ||
      address.trim() === "" ||
      activityName === ""
    ) {
      setAddresValidation(t("error_fill_all"));
    } else {
      setAddresValidation("");
      if (isSSO && !!state.email) {
        handleExternalRegister();
      } else {
        changeProviderRegistrationSteps(2);
      }
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      const resp = await get("/Activity");
      setCategories(resp);
    };
    fetchCategories();
    changePricePlan(pricePlan);
  }, []);

  useEffect(() => {
    if (providerRegistrationSteps > 0) {
      window.addEventListener("beforeunload", (event) => {
        event.preventDefault();
      });
    }
  }, [providerRegistrationSteps]);

  return (
    <>
      {loading && <Loader />}
      {providerRegistrationSteps === 0 ? (
        <div className="provider-registraton-category">
          <MainHeader />

          <div className="provider-registraton-subtext">
            <h2>{t("what_teach")}</h2>
          </div>
          {categories.length > 0 && (
            <div className="provider-registraton-categories">
              {categories.map((category) => (
                <div
                  key={`${category.category}-${category.id}`}
                  className="categories-section"
                >
                  <h1>{t(removeExtraChars(category.category))}</h1>

                  <ul>
                    {category.subCategories.map((item, index) => {
                      const Icon = renderIcon(item);

                      const IocnToPass = Icon ? <Icon /> : <span>Icon</span>;
                      return (
                        <li key={`${index}-${item}`}>
                          <RegisteredActivities
                            action={() => {
                              changeActivityName(item);
                              selectCategory(category.category);
                              changeProviderRegistrationSteps(1);
                            }}
                            icon={IocnToPass}
                            text={t(removeExtraChars(item))}
                          />
                        </li>
                      );
                    })}
                    <li>
                      <RegisteredActivities
                        action={() => {
                          setOtherActivityName("other");
                          selectCategory(category.category);
                          changeProviderRegistrationSteps(1);
                        }}
                        text={t("other")}
                      />
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          )}
          <div className="provider-registraton-categories-footer">
            <BackButton />
          </div>
        </div>
      ) : null}

      {providerRegistrationSteps === 1 ? (
        <div className="provider-registraton-adderss">
          <MainHeader />
          <div className="provider-registraton-subtext">
            <h3>
              {otherActivityName === "other"
                ? t("provider_regitration_subheader1")
                : t("provider_regitration_subheader2")}
            </h3>
          </div>
          <div className="provider-address-form">
            <form onSubmit={handleSubmitAddress}>
              {otherActivityName === "other" ? (
                <Input
                  name="activityName"
                  label={t("input_label_activity_type")}
                  value={activityName}
                  onChange={handleInputChange}
                />
              ) : null}
              <CountrySelect
                onChange={(newValue) => changeCountry(newValue || null)}
              />

              <Input
                name="city"
                label={t("input_label_city")}
                value={city}
                onChange={handleInputChange}
              />

              <Input
                name="district"
                label={t("input_label_district")}
                value={district}
                onChange={handleInputChange}
              />

              <Input
                name="address"
                label={t("input_label_address")}
                value={address}
                onChange={handleInputChange}
              />

              <div className="address-form-buttons">
                <BackButton
                  onClick={() => {
                    changeProviderRegistrationSteps(0);
                    setAddresValidation("");
                    setOtherActivityName("");
                    selectCategory("");
                  }}
                />
                <CustomButton type="submit">
                  {t(isSSO && !!state.email ? "sign_up" : "next")}
                </CustomButton>
              </div>
            </form>
          </div>

          <div className="adddress-validation">
            <h3>{addressValidation || registerValidation}</h3>
          </div>
        </div>
      ) : null}

      {providerRegistrationSteps === 2 ? <Registration /> : null}
    </>
  );
};

export default ProviderRegistration;
